import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { initializeList } from '../search-slice';
import { getSearchStore } from './store-manager';

interface SearchAppProps {
	initialList: any[],
	appName: string
}


export const SearchApp = (props: React.PropsWithChildren<SearchAppProps>) => {

	const store = getSearchStore(props.appName);
	useEffect(() => {
		store.dispatch(initializeList(props.initialList, props.appName));
	});
	return (
		<Provider store={store}>
			{
				props.children
			}
		</Provider>
	);

};